<ion-content>
	<div class="splash-container" [style.background-color]="data.bgColor">
		<img *ngIf="data.logo" [src]="data.logo"  />
	</div>
</ion-content>